import mapboxgl from 'mapbox-gl';

const collegeBuildingNamesByCode = {
    C1: { title: 'ALMUZN BUILDING', titleAr: 'مبنى المزن' },
    C2: { title: 'AL QURM BUILDING', titleAr: 'مبنى القرم' },
    C3: { title: 'AL MARSA BUILDING', titleAr: 'مبنى المرسى' },
    C4: { title: 'AL SADU BUILDING', titleAr: 'مبنى السدو' },
    C5: { title: 'AL WASEL BUILDING', titleAr: 'مبنى الوصل' },
    C6: { title: 'AL BARAJEEL BUILDING', titleAr: 'مبنى البراجيل' },
    E1: { title: 'AL HUSON BUILDING', titleAr: 'مبنى الحصن' },
    E2: { title: 'UAEU LABS 1', titleAr: 'مختبرات جامعة الإمارات 1' },
    E3: { title: 'UAEU LABS 2', titleAr: 'مختبرات جامعة الإمارات 2' },
    E4: { title: 'UAEU LABS 3', titleAr: 'مختبرات جامعة الإمارات 3' },
    E5: { title: 'UAEU LABS 4', titleAr: 'مختبرات جامعة الإمارات4' },
    E6: { title: 'UAEU LABS 5', titleAr: 'مختبرات جامعة الإمارات 5' },
    E7: { title: 'UAEU LABS 6', titleAr: 'مختبرات جامعة الإمارات 6' },
    E8: { title: 'District 4.0 Lab', titleAr: 'مختبر المنطقة الصناعية 4.0' },
    F1: { title: 'AL SIDRA BUILDING', titleAr: 'مبنى السدرة' },
    F2: { title: 'AL SIDRA BUILDING LABS', titleAr: 'مختبرات مبنى السدرة' },
    F3: { title: 'AL WAHA BUILDING', titleAr: 'مبنى الواحة' },
    F4: { title: 'NSSTC', titleAr: 'المركز الوطني لعلوم وتكنولوجيا الفضاء' },
    H1: { title: 'AL BATEEN BUILDING', titleAr: 'مبنى البطين' },
    H2: { title: 'AL SAMEEH BUILDING', titleAr: 'مبنى السميح' },
    H3: { title: 'DALMA BUILDING', titleAr: 'مبنى دلما' },
    H4: { title: 'HILI BUILDING', titleAr: 'مبنى هيلي' }
};

const collegeBuildingCodeByCollegeId = {
    'PO-53': 'C5'
};

const MapBox = {
    popup : new mapboxgl.Popup(),
    toolTip : (e) => {
        var tooltip = document.createElement('div');
            tooltip.setAttribute('class', 'tooltip');
            tooltip.setAttribute('id', `tooltip-${e.features[0].properties.id}`);
            // tooltip.setAttribute('style', `left: ${e.point.x}px; top: ${e.point.y}px;`);
            tooltip.textContent = e.features[0].properties.title;

        var mapDiv = document.getElementById('map');
        mapDiv.appendChild(tooltip);

        setTimeout(() => {
            tooltip.classList.add('tooltip-visible');
        }, 100);
    },

    getLinks : (links) => {
        var linkArr;
        if (typeof links == 'string') {
            linkArr = JSON.parse(links);
        } else {
            linkArr = links;
        }

        var link = '';

        linkArr.sort(function(obj1, obj2) {
            return obj1.order - obj2.order;
        });
        for (let i = 0; i < linkArr.length; i++) {
            link += linkArr[i].url == '' ? '<li>' + linkArr[i].title + '</li>' : '<li><a target="_blank" href="' + linkArr[i].url + '">' + linkArr[i].title + '</a></li>';
        }
        return link;
    },

    getContacts : (links) => {
        var linkArr;
        if (typeof links == 'string') {
            linkArr = JSON.parse(links);
        } else {
            linkArr = links;
        }

        var link = '';

        linkArr.sort(function(obj1, obj2) {
            return obj1.order - obj2.order;
        });
        for (let i = 0; i < linkArr.length; i++) {
            link += '<li>' + linkArr[i].text + '</li>';
        }
        return link;
    },

    getLocationCode : (location) => {
        let value = location;
        if (Array.isArray(value)) {
            value = value.join(', ');
        }

        const firstLocationPart = String(value || '')
            .split('Postal Address')[0]
            .split(',')[0]
            .trim()
            .toUpperCase();

        return /^[A-Z]+[0-9]+$/.test(firstLocationPart) ? firstLocationPart : '';
    },

    getCollegeBuilding : (properties) => {
        if (!properties || properties.type !== 'college' || !properties.location) {
            return '';
        }

        let location = properties.location;
        if (Array.isArray(location)) {
            location = location.join(', ');
        }

        location = String(location).trim();
        if (!location || location === 'null') {
            return '';
        }

        const buildingCode = collegeBuildingCodeByCollegeId[properties.id] || MapBox.getLocationCode(location);
        const building = collegeBuildingNamesByCode[buildingCode];
        if (building) {
            const titleAr = building.titleAr ? '<span class="mapboxgl-popup-meta-value-ar" dir="rtl">' + building.titleAr + '</span>' : '';
            return '<div class="mapboxgl-popup-meta"><span class="mapboxgl-popup-meta-value">' + building.title + '</span>' + titleAr + '</div>';
        }

        if (MapBox.getLocationCode(location)) {
            return '';
        }

        const cleanLocation = location
            .split('Postal Address')[0]
            .split(',')[0]
            .trim();

        if (!cleanLocation) {
            return '';
        }

        return '<div class="mapboxgl-popup-meta"><span class="mapboxgl-popup-meta-value">' + cleanLocation + '</span></div>';
    },

    popUp : (e , map) => {
        let features = e.features ? e.features[0] : e ;

        //return false;
        let properties = features.properties;
        let latLong = features.geometry.coordinates;
        let titleAr = properties.title_ar ? '<div class="mapboxgl-popup-title-ar" dir="rtl">' + properties.title_ar + '</div>' : '';
        let collegeBuilding = MapBox.getCollegeBuilding(properties);
        let html = '<div class="mapboxgl-popup-inner">' +
                        '<h3 class="mapboxgl-popup-title">' + properties.title + '</h3>' +
                        titleAr +
                        collegeBuilding +
                        '<div class="mapboxgl-popup-img" style="background-image: url(' + properties.img + ');"></div>' + 
                        '<ul class="no-list mapboxgl-popup-links">' + MapBox.getLinks(properties.links) + '</ul>' + 
                        '<ul class="no-list mapboxgl-popup-links">' + MapBox.getContacts(properties.contact) + '</ul>' + 
                        '<div>' + properties.id.trim().toLowerCase().replace('po-','<img src="https://www.uaeu.ac.ae/images/map/map-pin.png"> '); + '</div>' + 
                    '</div>';
        
        
                    
                
        setTimeout(() => {
            MapBox.popup.setLngLat(latLong).setHTML(html).addTo(map);
            
        }, 100);

        MapBox.popup.remove();

        map.flyTo({
            center: latLong,
            speed: 0.2,
            zoom: 16
        });

    }
}
export default MapBox;



// WEBPACK FOOTER //
// ./src/utils/Mapbox.js